import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import MobileNav from './components/MobileNav';
import Overview from './modules/Overview';
import CommandCenter from './modules/CommandCenter';
import DemoCenter from './modules/DemoCenter';
import Timeline from './modules/Timeline';
import GuestList from './modules/GuestList';
import VendorBoard from './modules/VendorBoard';
import BudgetPlanner from './modules/BudgetPlanner';
import Settings from './modules/Settings';
import './index.css';

function App() {
  const [activeTab, setActiveTab] = useState('overview');

  const renderContent = () => {
    switch (activeTab) {
      case 'overview': return <Overview />;
      case 'dashboard': return <CommandCenter />;
      case 'demo': return <DemoCenter />;
      case 'timeline': return <Timeline />;
      case 'guests': return <GuestList />;
      case 'vendors': return <VendorBoard />;
      case 'budget': return <BudgetPlanner />;
      case 'settings': return <Settings />;
      default: return <Overview />;
    }
  };

  return (
    <div className="h-screen w-full flex overflow-hidden relative selection:bg-[#9D4EDD]/30 selection:text-white">
      {/* Global Background Effect */}
      <div className="cosmic-bg"></div>

      {/* Sidebar Navigation */}
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      {/* Main Viewport */}
      <main className="flex-1 h-full w-full relative z-10 p-4 sm:p-6 lg:p-12 overflow-hidden flex flex-col">
        <div className="h-full w-full max-w-7xl mx-auto flex flex-col flex-1">
          {renderContent()}
        </div>
      </main>

      {/* Mobile Navigation */}
      <MobileNav activeTab={activeTab} setActiveTab={setActiveTab} />
    </div>
  );
}

export default App;